export const EngagementStatus = {
  Contacted: 'Contacted',
  Prospect: 'Prospect',
  Attempted: 'Attempted',
  Abandoned: 'Abandoned',
}
